import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'yesNo',
    standalone: false
})
export class YesNoPipe implements PipeTransform {
  constructor(private translate: TranslateService) { }
  transform(value) {
    return !!value ? this.translate.instant('boolean.true') : this.translate.instant('boolean.false');
  }
}
